<template>
  <div>
    <h2 class="tit-30 fw700">维保订单</h2>
    <div class="empty-tip txt-c">
      <img
        src="https://img.yzcdn.cn/vant/empty-image-default.png"
        alt="暂无订单"
      />
      <p>亲，暂无订单信息哟~</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderWeiBaoIndex",
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
